import { Component } from '@angular/core';
import { AppUpdateService } from '../../services/app-update.service';

@Component({
    selector: 'app-update-banner',
    templateUrl: './update-banner.component.html',
    styleUrls: ['./update-banner.component.scss'],
    standalone: false
})
export class UpdateBannerComponent {
  updateAvailable$ = this.appUpdateService.updateAvailable$;
  secondsUntilReload$ = this.appUpdateService.secondsUntilReload$;
  countdownSeconds = this.appUpdateService.countdownSeconds;

  constructor(private appUpdateService: AppUpdateService) {}

  refresh(): void {
    this.appUpdateService.reload();
  }

  snooze(): void {
    this.appUpdateService.snooze();
  }
}
